module.exports = __webpack_public_path__ + "img/fr_fr.551fa2e6.png";